import {
  HTTP_INTERCEPTORS,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { concatMap, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AuthService } from '../auth/auth.service';

@Injectable()
export class ScopedTokenInterceptor implements HttpInterceptor {
  constructor(
    private auth: AuthService,
  ) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (!request.url.includes(environment.dataIntegrityApiUrl)) {
      return next.handle(request);
    }

    return this.auth.scopedTokenStream.pipe(
      concatMap((token) => {
        const prefix = this.auth.version === 'v2' ? 'Bearer' : 'JWT';

        const clonedRequest = !token || !prefix ? request : request.clone({
          setHeaders: {
            Authorization: `${prefix} ${token}`,
          },
        });

        return next.handle(clonedRequest);
      }),
    );
  }
}

export const scopedTokenInterceptorProvider = [
  {
    provide: HTTP_INTERCEPTORS,
    useClass: ScopedTokenInterceptor,
    multi: true,
  },
];
